export default class ValidationException extends Error {
  constructor(message, data) {
    super(message)
    this.message = message
    this.fields = data
  }
}
